import {defaultAxios} from "../base";

interface IFetchHouseReqList {

}

// 주담대 대출 신청 내역 조회
export const fetchHouseReqList = async (params: IFetchHouseReqList) => {
    return await defaultAxios().post('/house/cust/reqList', params);
}